import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EBuildersProjectsActionType, TStartFetching } from './types';

export const startFetching: () => TStartFetching = actionGenerator<EBuildersProjectsActionType.StartFetching>(
  EBuildersProjectsActionType.StartFetching,
);
